export default "__VITE_PUBLIC_ASSET__48705f24__"